export interface BetaFeature {
  id: string;
  enabled: boolean;
  name: string;
}

export enum LocationCodeStandard {
  IATA = 'IATA',
  ICAO = 'ICAO'
}

export const DEFAULT_LOCATION_CODE = LocationCodeStandard.ICAO;

export interface Organisation {
  [x: string]: any;
  org: {
    betaFeatures?: BetaFeature[];
    id: string;
    orgName: string;
    spiderTxtEnabled: boolean;
    subscriptions: {
      status: 'ENABLED' | 'DISABLED';
      name: 'SCHEDULE' | 'SPIDERTXT';
    }[];
    locationCodePreference?: LocationCodeStandard;
  };
  role: 'ADMIN' | 'MEMBER' | 'OWNER';
}
